import React from "react";
import "./Dashboard.css";
import DijonCard from "./DijonCard";
import OpenBBPage from "../OpenBB/OpenBBPage";

function DijonOpenBB(props) {
  return (
    <div id="openbb-card">
      <DijonCard
        width={"80vw"}
        height={"85vh"}
        defaultX={0}
        activeCards={props.activeCards}
        setActiveCards={props.setActiveCards}
        name={"openbb"}
        content={
          <div style={{ height: "100%", width: "100%", overflow: "auto", position: "relative", background: "#141414" }}>
            <OpenBBPage />
          </div>
        }
      />
    </div>
  );
}

export default DijonOpenBB;
